import React from 'react'
import { Switch, Route } from 'react-router-dom'
import ProtectedRoute from './ProtectedRoute'
import NotLoggedInRoute from './NotLoggedInRoute'
import { Redirect } from 'react-router-dom'

import * as paths from './constants'
import Login from '../Login'
import Register from '../Register'
// import MainRedirect from './MainRedirect' // @deprecated - now it should redirect always to applications lists path
import AccountVerification from '../AccountVerification'
import Application from '../Applications/Application'
import ApplicationsList from '../Applications/ApplicationsList'
import Profile from '../Profile'
import RecoverPassword from '../PasswordRecovery/RecoverPassword'
import ResetPassword from '../PasswordRecovery/ResetPassword'

function MainRedirect() {
  return <Redirect to={paths.APPLICATIONS_PATH} />
}

function MainRoutes() {
  return (
    <Switch>
      <ProtectedRoute path='/' component={MainRedirect} exact />
      <Route path={paths.ACCOUNT_VERIFICATION} component={AccountVerification} exact />
      <NotLoggedInRoute path={paths.LOGIN_PATH} component={Login} exact />
      <NotLoggedInRoute path={paths.REGISTER_PATH} component={Register} exact />
      <NotLoggedInRoute path={paths.RECOVER_PASSWORD} component={RecoverPassword} exact />
      <Route path={paths.RESET_PASSWORD} component={ResetPassword} exact />
      <ProtectedRoute path={paths.APPLICATIONS_PATH} exact component={ApplicationsList} />
      <ProtectedRoute path={paths.APPLY_PATH} component={Application} />
      <ProtectedRoute path={paths.PROFILE} component={Profile} />
    </Switch>
  )
}

export default MainRoutes
